var _excluded = ["active", "index", "onClick"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { styled } from '@grupoboticario/flora';
import { forwardRef } from '@grupoboticario/flora-react';
import React, { useCallback, useContext } from 'react';
import { CarouselContext } from '../Carousel';
var StyledDot = styled('button', {
  all: 'unset',
  display: 'inline-block',
  backgroundColor: 'transparent',
  boxShadow: 'inset 0 0 0 1px $$boxShadowNormal',
  borderRadius: '$small',
  cursor: 'pointer',
  height: '$2',
  position: 'relative',
  width: '$2',
  transition: 'background-color 300ms ease-out, box-shadow 300ms ease-out, width 300ms ease-out',
  '&[data-state="on"]': {
    width: '$7',
    backgroundColor: '$$backgroundColorOn',
    boxShadow: 'none'
  },
  '&[data-state="off"]:hover': {
    backgroundColor: '$$backgroundColorHoverOff',
    boxShadow: 'inset 0 0 0 1px $$boxShadowNormalHover'
  },
  '&:focus': {
    boxShadow: '$outline'
  },
  '&::before': {
    content: '',
    height: '100%',
    left: ' 50%',
    minHeight: '$4',
    minWidth: '$6',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    top: '50%',
    width: '100%'
  },
  variants: {
    color: {
      standard: {
        $$boxShadowNormal: '$colors$actionableDefault',
        $$boxShadowNormalHover: '$colors$actionableHover',
        $$backgroundColorOn: '$colors$disabledBackground',
        $$backgroundColorHoverOff: '$colors$actionableHover'
      },
      alt: {
        $$boxShadowNormal: '$colors$actionableAlt',
        $$boxShadowNormalHover: '$colors$actionableAlt',
        $$backgroundColorOn: '$colors$disabledAltBackground',
        $$backgroundColorHoverOff: '$colors$actionableAlt'
      }
    }
  },
  defaultVariants: {
    color: 'standard'
  }
});
export var Dot = forwardRef((_ref, forwardedRef) => {
  var {
    active,
    index,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var {
    state: {
      goTo,
      onDotPress
    }
  } = useContext(CarouselContext);
  var handleOnClick = useCallback(event => {
    goTo(index);
    onDotPress(index);
    onClick == null ? void 0 : onClick(event);
  }, [goTo, index, onClick, onDotPress]);
  return /*#__PURE__*/React.createElement(StyledDot, _extends({}, props, {
    onClick: handleOnClick,
    role: "checkbox",
    "aria-checked": !!active,
    "data-slide-index": index,
    "data-state": !!active ? 'on' : 'off',
    ref: forwardedRef
  }));
});
//# sourceMappingURL=NavigationDot.js.map